import {BaseContainerModel} from '../base-container.model';

import{
    bl_applet_notification_login_subject_subscription_RowInterface,
    bl_applet_notification_login_subject_subscription_RowClass
} from "../../dbschema"

export class AppletNotificationLoginSubscriptionContainerModel extends BaseContainerModel{
    bl_applet_notification_login_subject_subscription: bl_applet_notification_login_subject_subscription_RowClass = new bl_applet_notification_login_subject_subscription_RowClass();
}